import LibraryMediaItem from './library-media-item'
import { MediaGrid } from './library-media.style'
import { MdPlayCircleOutline, MdWallpaper } from "react-icons/md";

const LibraryMedia = () => {
    return (
        <MediaGrid>

            <LibraryMediaItem subject="Mathematics" imgUrl="/assets/images/subject/subject-maths.webp" icon={<MdPlayCircleOutline />} />
            <LibraryMediaItem subject="Computer Sci" imgUrl="/assets/images/subject/subject-compsci.webp" icon={<MdPlayCircleOutline />} />
            <LibraryMediaItem subject="Biology" imgUrl="/assets/images/subject/subject-biology.webp" icon={<MdPlayCircleOutline />} />
            <LibraryMediaItem subject="P.E" imgUrl="/assets/images/subject/subject-pe.webp" icon={<MdWallpaper />} />

        </MediaGrid>
    )
}

export { LibraryMedia }
